import { Box, styled, Typography } from '@mui/material';

export default function PastDivider() {
    return (
        <Root>
            <Typography variant="overline"
                fontWeight="bold"
            >Past</Typography>
        </Root>
    );
}

const Root = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    '&::before, &::after': {
        content: '""', flex: 1, height: 0, borderTop: '1px solid transparent',
        borderImage: 'repeating-linear-gradient(to right, currentColor 0 10px, transparent 10px 14px) 1'
    }
}));
